module.exports = __webpack_public_path__ + "static/media/banner2.ee2eb947.jpg";